var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8086 16.978L28.1141 22.8205L30.1195 31.5189C30.2256 31.9736 30.1953 32.4496 30.0324 32.8872C29.8695 33.3248 29.5812 33.7047 29.2036 33.9793C28.826 34.254 28.3758 34.4113 27.9093 34.4314C27.4428 34.4516 26.9806 34.3338 26.5807 34.0928L18.9941 29.4913L11.4238 34.0928C11.0238 34.3338 10.5617 34.4516 10.0952 34.4314C9.62869 34.4113 9.17848 34.254 8.80086 33.9793C8.42324 33.7047 8.13496 33.3248 7.97206 32.8872C7.80917 32.4496 7.77889 31.9736 7.88501 31.5189L9.88743 22.8294L3.19141 16.978C2.83726 16.6725 2.58116 16.2693 2.45525 15.8189C2.32933 15.3685 2.3392 14.8909 2.48362 14.4461C2.62804 14.0013 2.90058 13.609 3.26706 13.3184C3.63353 13.0279 4.07764 12.852 4.54368 12.8128L13.3698 12.0484L16.815 3.83088C16.9949 3.39969 17.2984 3.03137 17.6872 2.7723C18.076 2.51324 18.5328 2.375 19 2.375C19.4672 2.375 19.924 2.51324 20.3128 2.7723C20.7016 3.03137 21.0051 3.39969 21.185 3.83088L24.6406 12.0484L33.4638 12.8128C33.9298 12.852 34.3739 13.0279 34.7404 13.3184C35.1069 13.609 35.3794 14.0013 35.5238 14.4461C35.6682 14.8909 35.6781 15.3685 35.5522 15.8189C35.4263 16.2693 35.1702 16.6725 34.816 16.978H34.8086Z",
    fill: "#6B7A7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.84c8099badd69ed53f6d990abd839aaa.svg";
export { ForwardRef as ReactComponent };